import React, { useState } from 'react'
import {
  Toolbar,
  Typography,
  IconButton,
  Badge,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import {
  Menu as MenuIcon,
  Logout,
  Person,
} from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../../contexts/AuthContext'

interface TopBarProps {
  onMenuClick: () => void
}

const TopBar: React.FC<TopBarProps> = ({ onMenuClick }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const navigate = useNavigate()
  const { user, logout } = useAuth()
  
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = async () => {
    handleMenuClose()
    await logout()
  }

  const handleProfile = () => {
    handleMenuClose()
    navigate('/profile')
  }

  const renderProfileMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
    >
      <Box sx={{ px: 2, py: 1, minWidth: 200 }}>
        <Typography variant="subtitle2" noWrap>
          {user?.name}
        </Typography>
        <Typography variant="body2" color="text.secondary" noWrap>
          {user?.employee_id} | {user?.department}
        </Typography>
      </Box>
      <Divider />
      <MenuItem onClick={handleProfile}>
        <ListItemIcon>
          <Person fontSize="small" />
        </ListItemIcon>
        <ListItemText>プロフィール</ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        <ListItemText>ログアウト</ListItemText>
      </MenuItem>
    </Menu>
  )

  return (
    <>
      <Toolbar>
        {/* モバイル用メニューボタン */}
        {isMobile && (
          <IconButton
            color="inherit"
            edge="start"
            onClick={onMenuClick}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        {/* タイトル */}
        <Typography 
          variant="h6" 
          noWrap 
          component="div" 
          sx={{ 
            flexGrow: 1,
            fontWeight: 600,
          }}
        >
          TGS社内管理システム
        </Typography>

        {/* 右側のアイコン群 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* プロフィールアイコン */}
          <IconButton
            edge="end"
            onClick={handleProfileMenuOpen}
            color="inherit"
            aria-label="アカウントメニュー"
          >
            <Avatar 
              sx={{ 
                width: 32, 
                height: 32,
                bgcolor: 'primary.dark',
                fontSize: '0.875rem',
              }}
            >
              {user?.name?.charAt(0)}
            </Avatar>
          </IconButton>
        </Box>
      </Toolbar>

      {renderProfileMenu}
    </>
  )
}

export default TopBar